<div class="fixed w-full h-full top-0 z-10 flex flex-wrap justify-center content-center p-24">
   <div class="w-[300px] rounded-3xl bg-white shadow-xl overflow-hidden z-50 relative right-[8%]">
      <div class="text-left w-full text-sm px-6 py-2 overflow-auto">
         <div class="text-center ">
            <div class="text-xl font-semibold">Elimina quantità</div>
            <hr class="my-2">

            <div class="font-bold">QTA nel carrello: {{component.itemSel.get('qta')?.value}}</div>

            <div *ngFor="let item of component.itemSel.get('barcodes')?.controls" class="my-3">
               <button type="button" class="btn btn-conferma" (click)="clickRemoveQtaAndBarcode(item.value, component.itemSel)">
                  {{item.value}}
               </button>
            </div>
            <div class="px-5 py-0 overflow-auto z-50 scroll-pb-96">
               <app-barcode-input [appearance]="'outline'"
                                  [placeholder]="'Inserisci barcode da eliminare'"
                                  [autofocus]="true"
                                  [classObject]="component.PVenditaProdVarInst"
                                  [requestValue]="false"
                                  (outputValue)="clickRemoveQtaAndBarcode($event, component.itemSel)">
               </app-barcode-input>
            </div>

            <div class="grid gap-2" [ngClass]="component.itemSel.get('qta')?.value ==  component.itemSel.get('barcodes')?.length ? 'grid-cols-1' : 'grid-cols-2'">
               <button *ngIf="component.itemSel.get('qta')?.value > component.itemSel.get('barcodes')?.length" type="button" class="btn btn-conferma" (click)="clickRemoveQtaAndBarcode(null, component.itemSel)">
                  Nessun codice
               </button>

               <button type="button" class="btn btn-danger" (click)="component.clickRemoveElementCart(component.indexSel)">
                  Elimina prodotto
               </button>
            </div>

         </div>
         <hr class="my-2">
      </div>
      <div class="px-5 py-0 overflow-auto z-50 scroll-pb-96">
      </div>
   </div>
   <div class="fixed glass w-full h-screen left-0 top-0 z-40" (click)="component.isShowModalDeleteBarcode = false"></div>
</div>
